import { evolucional_redirect_url } from "../constants/general";
import { redirect } from "./misc";

export function logout() {
    this.isLoading();
    this.$store.dispatch("logout")
        .then(() => {
            redirect(process.env.NODE_ENV === "development" ? "/admin/login" : evolucional_redirect_url);
        })
}